var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/send/filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M6.29602 3.40554C3.91012 2.30435 1.36183 4.58519 2.19279 7.0781L3.45424 10.8192C3.59136 11.2258 3.97267 11.4997 4.40182 11.4997H13C13.5523 11.4997 14 11.9474 14 12.4997C14 13.052 13.5523 13.4997 13 13.4997H4.40182C3.97267 13.4997 3.59136 13.7735 3.45424 14.1802L2.19281 17.9213C1.36183 20.4142 3.91012 22.695 6.29603 21.5938L20.0983 15.2236C22.422 14.1511 22.422 10.8483 20.0983 9.77583L6.29602 3.40554Z",
    fill: "#FCFCFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilled);
export default __webpack_public_path__ + "static/media/filled.d788f0069a98687fd578cd8223a846c7.svg";
export { ForwardRef as ReactComponent };